import { render } from "./klb-q7.vue?vue&type=template&id=1aec376c&scoped=true"
import script from "./klb-q7.vue?vue&type=script&lang=js"
export * from "./klb-q7.vue?vue&type=script&lang=js"

import "./klb-q7.vue?vue&type=style&index=0&id=1aec376c&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aec376c"]])

export default __exports__